// @ts-strict-ignore
import { fileExtensionToTypeMap, fileTypeToExtensionMap } from "../constants";
import type { AllowedFilters, SupportedExtensions, SupportedTypes } from "../types";

/**
 * Given a list of types or file extensions, extract the filters and groupings allowed in the media library
 */
export const extractAllowedFilters = (
  fileExtensions: Array<SupportedExtensions | SupportedTypes> | undefined
): AllowedFilters => {
  if (!fileExtensions) {
    return {};
  }
  const extractedFileExtensions: AllowedFilters = {};

  // first, iterate over the extensions to get a map of extension type to extension
  for (const ext of fileExtensions) {
    const type: SupportedTypes = fileExtensionToTypeMap[ext as SupportedExtensions] || "other";
    extractedFileExtensions[type] = extractedFileExtensions[type] || {};
    switch (ext) {
      case "image": {
        ["jpg", "png", "gif", "webp", "svg", "ico"].forEach((ext) => {
          extractedFileExtensions[type][ext] = true;
        });
        break;
      }
      case "video": {
        ["mp4"].forEach((ext) => {
          extractedFileExtensions[type][ext] = true;
        });
        break;
      }
      case "font": {
        ["ttf", "otf", "woff", "woff2"].forEach((ext) => {
          extractedFileExtensions[type][ext] = true;
        });
        break;
      }
      case "code": {
        ["js", "css"].forEach((ext) => {
          extractedFileExtensions[type][ext] = true;
        });
        break;
      }
      case "document": {
        fileTypeToExtensionMap.document.forEach((extension) => {
          extractedFileExtensions[type][extension] = true;
        });
        break;
      }
      case "other": {
        ["vcf"].forEach((ext) => {
          extractedFileExtensions[type][ext] = true;
        });
        break;
      }
      case "jpeg":
      // fall through
      case "jpg": {
        extractedFileExtensions.image.jpg = true;
        break;
      }
      default: {
        extractedFileExtensions[type][ext] = true;
      }
    }
  }

  return extractedFileExtensions;
};
